import * as yup from 'yup';

export const useStartLicenceFormSchema = () => {
  const schema = yup.object({
    licenceData: yup.string().required('This field is required.').trim(),
  });

  return { schema };
};
